export function redirectToLogin(serverContext) {
  const { Urls: { SignOutUrl } = {} } = serverContext;

  window.location.href = SignOutUrl ||
    `${window.location.protocol}//${window.location.host}/default.aspx?reason=1&msg=sessionexpired`;
}

const prodEnvs = [
  // CMUI
  'ui.bingads.microsoft.com',
  'ui.beta.bingads.microsoft.com',
  'ui.ads.microsoft.com',
  'ui.beta.ads.microsoft.com',
  // CCUI
  'bingads.microsoft.com',
  'beta.bingads.microsoft.com',
  'ads.microsoft.com',
  'beta.ads.microsoft.com',
];

export function isTestEnvironment(envToCheck) {
  return prodEnvs.indexOf(envToCheck) === -1;
}

export function isSignupRunningProxy() {
  return window.location.port === '12000' && window.location.host === 'ads-int.microsoft.com';
}

export const PROJECTS = {
  DMC: 'DMC',
  UP: 'UP',
  CAMPAIGN_UI: 'CAMPAIGN_UI',
  SMART: 'SMART',
  SMART_PAGE: 'SMART_PAGE',
  UP_SUPPORT: 'UP_SUPPORT',
  SUB_ADS_LANDING: 'SUB_ADS_LANDING',
  DSP: 'DSP',
  SELLER_FORUM: 'SELLER_FORUM',
  STREAMLINED_SIGNUP: 'STREAMLINED_SIGNUP',
  PMAX_LITE_SIGNUP: 'PMAX_LITE_SIGNUP',
  PMAX_LITE_LANDING: 'PMAX_LITE_LANDING',
  OMS: 'OMS',
};

// All MS Ads products use the same clarity ID
const PROD_CLARITY_ID = '4jwlwd615c';
const TEST_CLARITY_ID = '6vo4jbalnn';

// from clarity.microsoft.com
export const CLARITY_IDS = {
  [PROJECTS.DMC]: '4w966avnz2',
  [PROJECTS.CAMPAIGN_UI]: PROD_CLARITY_ID,
  [PROJECTS.UP]: PROD_CLARITY_ID,
  [PROJECTS.SMART]: PROD_CLARITY_ID,
  [PROJECTS.SMART_PAGE]: PROD_CLARITY_ID,
  [PROJECTS.UP_SUPPORT]: PROD_CLARITY_ID,
  [PROJECTS.SUB_ADS_LANDING]: PROD_CLARITY_ID,
  [PROJECTS.DSP]: 'az4m3zmuo0',
  [PROJECTS.SELLER_FORUM]: PROD_CLARITY_ID,
  [PROJECTS.STREAMLINED_SIGNUP]: PROD_CLARITY_ID,
  [PROJECTS.PMAX_LITE_SIGNUP]: PROD_CLARITY_ID,
  [PROJECTS.PMAX_LITE_LANDING]: PROD_CLARITY_ID,
};

export const TEST_CLARITY_IDS = {
  [PROJECTS.DMC]: TEST_CLARITY_ID,
  [PROJECTS.CAMPAIGN_UI]: TEST_CLARITY_ID,
  [PROJECTS.UP]: TEST_CLARITY_ID,
  [PROJECTS.SMART]: TEST_CLARITY_ID,
  [PROJECTS.SMART_PAGE]: TEST_CLARITY_ID,
  [PROJECTS.UP_SUPPORT]: TEST_CLARITY_ID,
  [PROJECTS.SUB_ADS_LANDING]: TEST_CLARITY_ID,
  [PROJECTS.DSP]: 'az4mm7npsb',
  [PROJECTS.SELLER_FORUM]: TEST_CLARITY_ID,
  [PROJECTS.STREAMLINED_SIGNUP]: TEST_CLARITY_ID,
  [PROJECTS.PMAX_LITE_SIGNUP]: TEST_CLARITY_ID,
  [PROJECTS.PMAX_LITE_LANDING]: TEST_CLARITY_ID,
};
